// CustomError.js
class CustomError extends Error {
  constructor(message, details = []) {
    super(message);
    this.details = Array.isArray(details) ? details : [details];
  }
}

export default CustomError;
